function detailpopup(elem) { 

var detail = 
`<div class="both_table">
    <div class="grid-table">
        <div class="grid-row">
            <div class="grid-header"><div class="icon"><img src="img/locator.svg" alt=""></div>Country</div>
            <div id="country" class="grid-cell">---</div>
        </div>
        <div class="grid-row">
            <div class="grid-header"><div class="icon"><img src="img/trein.svg" alt=""></div>Time by train *</div>
            <div id="train_time" class="grid-cell">0h 0m</div>
        </div>
        <div class="grid-row">
            <div class="grid-header"><div class="icon"><img src="img/stap.svg" alt=""></div>Transfers</div>
            <div id="transfer" class="grid-cell">0</div>
        </div>
        <div class="grid-row">
            <div class="grid-header"><div class="icon"><img src="img/co2.svg" alt=""></div>Emission</div>
            <div id="emission_train" class="grid-cell">0kg</div>
        </div>
    </div>

    <div class="grid-table">
        <div class="grid-row">
            <div class="grid-header"><div class="icon"><img src="img/plane.svg" alt=""></div>Time by plane **</div>
            <div id="plane" class="grid-cell">0h 0m</div>
        </div>
        <div class="grid-row">
            <div class="grid-header"><div class="icon"><img src="img/co2.svg" alt=""></div>Emission</div>
            <div id="emission" class="grid-cell">0kg</div>
        </div>
    </div>
</div>
`;

elem.innerHTML += detail;
};